export function normalizeSearch(value) {
  // Utilidad para normalizar un string de cara a realizar busquedas.
  // Quita diacríticos (acentos, tildes, diéresis, cedillas, etc

  // Protegete si recibes cualquier cosa que no sea un string (undefined, null, objeto, array, numero, etc)
  // en cuyo caso se devuelve una cadena vacia, pero no se produce un error.
  const str = typeof value === 'string' ? value : ''

  return str
    .normalize('NFD') // descompone caracteres acentuados
    .replace(/\p{Diacritic}/gu, '') // quita todos los diacríticos
  //.trim()         // que sea el llamador quien lo haga si lo necesita
  //.toUpperCase()  // que sea el llamador quien lo haga si lo necesita
}
